<template>
  <router-view />
</template>

<script>
export default {
  
  name: 'App',
  html() {
    return {
      title: 'AdminPanel',
      meta: [
        { mid: 'theme-color', name: 'theme-color', content: '#0093dd', },
      ],
    }
  },
}
</script>
